<button
  type="button"
  id="btn-continue"
  class="btn btn-dark"
  (click)="navigateToNext()"
>
  {{ label }}
</button>
